import {useState, useEffect} from "react";

import JsonDataRenderer from "./JsonDataRenderer";
import WfpmPVisualizer from "./WfpmPVisualizer";
import MapHistoryVisualizer from './mapHistoryVisualizer/MapHistoryVisualizer';
import GeneralMapVisualizer from "./generalMapVisualizer/GeneralMapVisualizer";
import AzimuthVisualizer from "./azimyth/AzimuthVisualizer";


export default function ({dataType, dataToRender}) {
    const [result, setResult] = useState(null);

    useEffect(() => {
        if (dataType === "studio/text" && dataToRender) {
            setResult(<JsonDataRenderer data={dataToRender}/>);
        } else if (dataType === "studio/wfpm-pc-visual") {
            setResult(<WfpmPVisualizer data={dataToRender}/>);
        } else if (dataType === "studio/gm-visual") {
            setResult(<GeneralMapVisualizer data={dataToRender}/>);
        } else if (dataType === "studio/mh-visual") {
            setResult(<MapHistoryVisualizer data={dataToRender}/>);
        } else if (dataType === "studio/az-visual") {
            setResult(<AzimuthVisualizer data={dataToRender}/>);
        }
    }, [dataType, dataToRender]);

    return result;
}
